<template>
  <svg 
    fill="none" 
    height="24" 
    viewBox="0 0 24 24" 
    width="24" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect 
      fill="#5A627D" 
      fill-opacity="0.1" 
      height="24" 
      rx="4" 
      width="24"
    />
    <path 
      class="nlp__svg-path" 
      clip-rule="evenodd" 
      d="M19.6004 6.367L12.7646 11.983C12.3055 12.3311 11.6945 12.3311 11.2354 11.983L4.39962 6.367C4.76449 5.84055 5.34553 5.5 6 5.5H18C18.6545 5.5 19.2355 5.84055 19.6004 6.367ZM20 7.8502V16.3333C20 17.53 19.1046 18.5 18 18.5H6C4.89543 18.5 4 17.53 4 16.3333V7.8502L10.4708 13.1664C11.3889 13.8627 12.6111 13.8627 13.5292 13.1664L20 7.8502Z" 
      fill="#5A627D"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: 'NlpEmail',
}
</script>